module.exports = __webpack_public_path__ + "static/city_step02-f5c4b000dc0dea52861f8a0d05638cc0.png";